export const buildNumber = '20260723.2';
export const version = '3.14.2';
export const latestCommit = '2034597825998ac02d9c6f98cd61985826ad2889';
